// extracted by mini-css-extract-plugin
export default {"longtext":"Message_longtext__c3MVF"};